import React, { useState, useEffect } from 'react';
import { getConsent, setConsent } from '../utils/analytics';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
  }, []);

  if (!visible) return null;

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  return (
    <div style={styles.banner}>
      <p style={styles.text}>
        We use cookies to understand how the site is used and improve it.
        We don't use them to track you across other sites.
      </p>
      <div style={styles.btnRow}>
        <button style={styles.declineBtn} onClick={() => choose('declined')}>
          Decline
        </button>
        <button style={styles.acceptBtn} onClick={() => choose('accepted')}>
          Accept
        </button>
      </div>
    </div>
  );
}

const styles = {
  banner: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: '#111827',
    borderTop: '1px solid #1e2a3a',
    padding: '1rem 1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    flexWrap: 'wrap',
    zIndex: 999,
    boxShadow: '0 -4px 20px rgba(0,0,0,0.3)',
  },
  text: {
    color: '#9ca3af',
    fontSize: '0.8rem',
    margin: 0,
    flex: 1,
    minWidth: '250px',
    fontFamily: "'Syne', sans-serif",
  },
  btnRow: { display: 'flex', gap: '0.5rem', flexShrink: 0 },
  declineBtn: {
    background: 'transparent',
    color: '#6b7280',
    border: '1px solid #1e2a3a',
    borderRadius: '8px',
    padding: '0.5rem 1rem',
    fontSize: '0.8rem',
    cursor: 'pointer',
    fontFamily: "'Syne', sans-serif",
  },
  acceptBtn: {
    background: '#00d4aa',
    color: '#0a0f1e',
    border: 'none',
    borderRadius: '8px',
    padding: '0.5rem 1rem',
    fontSize: '0.8rem',
    fontWeight: '700',
    cursor: 'pointer',
    fontFamily: "'Syne', sans-serif",
  },
};
